import React from "react";
import { Link } from "gatsby";

const FooterAboutUs = ({ aboutUs = [] }) => {
  return (
    <div className="w-[35%]">
      <h4 className="text-xl font-bold leading-[30px] tracking-wide mb-5 mt-[30px]">
        About Us
      </h4>

      <div className="grid grid-cols-2 gap-x-10 justify-between">
        {/* <div> */}
        {aboutUs.map((value, id) => {
          if (value.slug.includes("bushbuck-club")) {
            return (
              <a
                href={value.slug}
                className="text-sm tracking-wide leading-[25px] cursor-pointer py-[5px] text-white opacity-60 no-underline 
                    hover:text-secondary-500 hover:opacity-100"
                key={id}
              >
                {value.title}
              </a>
            );
          } else {
            return (
              <Link
                to={value.slug}
                key={id}
                className="text-sm tracking-wide leading-[25px] cursor-pointer py-[5px] text-white opacity-60 no-underline 
                    hover:text-secondary-500 hover:opacity-100"
              >
                {value.title}
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
};

export default FooterAboutUs;
